<template>
    <div>
        <el-row class="padding_50">
            <el-col
                    :span="24"
                    class="margin_20"
            >
                <div style="margin-bottom:20px;color:#aaa;">请填写您已认证的手机号码以找回密码</div>
                <el-form ref="form" :model="form" :rules="rules">
                    <el-form-item prop="mobile">
                        <el-input
                            v-model="form.mobile"
                            size="medium"
                            :disabled="is_stay"
                            placeholder="手机号码"
                        />
                    </el-form-item>
                </el-form>
                <el-form ref="codeForm" :model="codeForm" :rules="codeRules">
                    <el-form-item prop="code">
                        <el-input size="medium" placeholder="手机验证码" v-model="codeForm.code" style="width: 50%"></el-input>
                        <el-button plain @click="getCode" :disabled="num < 120 || is_getCode" style="width: calc(50% - 20px);margin-left: 20px">{{btn_text}}</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col
                    :span="24"
                    class="margin_20"
                    style="margin-bottom: 20px"
            >
                <el-button
                        type="primary"
                        :loading="is_post"
                        style="width:100%;"
                        @click="submit"
                >
                    确认
                </el-button>
            </el-col>
            <el-col
                    :span="24"
                    class="margin_20"
            >
                <el-button
                        style="width:100%;"
                        @click="goBack()"
                >
                    返回
                </el-button>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import Cookies from 'js-cookie'
import request from '@/utils/request'

    export default {
        name: "auth_forgetPassword",
        data() {
            return {
                form: {
                    mobile: ""
                },
                is_post: false,
                is_getCode:false,
                codeForm:{
                    code:""
                },
                rules:{
                    mobile:[
                        { required: true, message: '请填写手机号', trigger: 'blur' },
                        { pattern:/^1[345789]\d{9}$/,message:"请填写正确的手机号",trigger:"blur" }
                    ]
                },
                codeRules:{
                    code:[
                        { required: true, message: '请填写手机验证码', trigger: 'blur' },
                        { pattern:/^\d{6}$/,message:"请填写正确的手机验证码",trigger:"blur" }
                    ]
                },
                btn_text:"获取短信验证码",
                clock:null,
                num:120,
                is_stay:false
            }
        },
        created() {

        },
        methods: {
            goBack(){
                this.$router.go(-1);
            },
            getCode(){
                this.$refs["form"].validate(valid=>{
                    if(!valid)return false;
                    this.is_getCode = true;
                    request.post("forget_pwd",this.form).then(res=>{
                        this.is_stay = true;
                        this.clock = setInterval(()=>{
                            this.num -= 1;
                            this.btn_text = `${this.num}秒之后重新获取`;
                            if(this.num == 0){
                                this.is_stay = false;
                                this.num = 120;
                                this.btn_text = "获取短信验证码";
                                clearInterval(this.clock);
                                this.clock = null;
                            }
                        },1000);
                        setTimeout(()=>{
                            this.is_getCode = false;
                        },1200);
                    }).catch(err=>{
                        this.is_getCode = false;
                    });
                });
            },
            submit(){
                this.$refs["form"].validate(valid=>{
                    if(!valid) return false;
                    this.$refs["codeForm"].validate(valid=>{
                        if(!valid) return false;
                        this.is_post = true;
                        request.post("verify_forget_pwd",{mobile:this.form.mobile,code:this.codeForm.code}).then(res=>{
                            //设置token
                            let expires = new Date(new Date() * 1 + 280 * 1000);
                            Cookies.set("forgetPwdTicket",res.data.uuid,{expires});
                            this.$router.push({name:"changePassword"});
                            this.$message.success("验证手机号通过!");
                        }).catch(err=>{
                            this.is_post = false;
                        });
                    });
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/styles/element-variables.scss";

    .padding_50 {
        padding: 20px 50px 20px 10px;
        @media (max-width: 767px) {
            padding: 0 0 0 0;
        }
    }

    .margin_20 {
        width: 100%;
        margin: 0px 20px 0 20px;
        padding: 0 30px;
        @media (max-width: 767px) {
            margin: 0;
            padding: 10px 0;
        }
    }

    .gray_text {
        color: #999;
    }

    .other_login_icon {
        margin-left: 16px;
        color: rgba(0, 0, 0, .2);
        font-size: 24px;
        vertical-align: middle;
        cursor: pointer;
        transition: color .3s;
        line-height: 0;
        text-align: center;
        &:hover {
            color: $--color-primary;
        }
    }
</style>
